export function scrollToTop() {
  window.scrollTo(0, 0); // Scrolls to the top of the page
}
